import { Injectable } from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {HttpClient} from "@angular/common/http";
import {environment} from "@Env/environment";
import {ModelPjType} from "app/dar/common/services/model-pj/model-pj.model";
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ModelPjTypeService extends DaoGeneric<ModelPjType>{
  private urlUpload = `${environment.baseUrl}/dar/attachmenttemplatetype/`;
  private subject: Subject<ModelPjType[]> = new Subject();
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(urlApp?: string): string {
    return this.urlUpload;
  }

  updateList(typeList: ModelPjType[]) {
    console.log('ModelPjTypeService updateList: ', typeList);
    this.subject.next(typeList);
  }

  getList(): Observable<ModelPjType[]> {
    return this.subject.asObservable();
  }
}
